/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';
import { getAccountId } from '../helper/routeHelper';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  getInboxCount() {
    return axios.get(`${this.url}/open_conversations_count`);
  }

  getWithdrawsList(params) {
    const { inboxId, ...rest } = params;
    const accountId = getAccountId();
    return axios.get(`/api/v1/accounts/1/withdraws`, {
      params: { ...rest, inbox: inboxId },
    });
  }

  updateWithdraw(params) {
    const { order_id, inboxId, status, utr, ...rest } = params;
    const accountId = getAccountId();
    return axios.patch(`/api/v1/accounts/1/withdraws/update_status_by_order_id_undelivered`, {
      order_id,
      inbox: inboxId,
      status,
      utr,
      ...rest,
    });
  }

  getRechargesList(params) {
    const { inboxId, ...rest } = params;
    const accountId = getAccountId();
    return axios.get(`/api/v1/accounts/1/recharges`, {
      params: { ...rest, inbox: inboxId },
    });
  }

  updateRecharge(params) {
    const { inboxId, ...rest } = params;
    const accountId = getAccountId();
    return axios.patch(`/api/v1/accounts/1/recharges/update_by_utr_upi`, {
      inbox: inboxId,
      ...rest,
    });
  }

  exportWithdrawsToExcel(params) {
    const { inboxId, ...rest } = params;
    const accountId = getAccountId();
    return axios.get(`/api/v1/accounts/1/withdraws/export`, {
      params: { ...rest, inbox: inboxId, max_count: 10000 },
      responseType: 'blob',
    });
  }

  exportRechargesToExcel(params) {
    const { inboxId, ...rest } = params;
    const accountId = getAccountId();
    return axios.get(`/api/v1/accounts/1/recharges/export`, {
      params: { ...rest, inbox: inboxId, max_count: 10000 },
      responseType: 'blob',
    });
  }
}

export default new Inboxes();
